import * as React from 'react';
import { MatchScore, SchoolEvent } from 'Src/models/event';
import './EventMatchResultSummary.scss';

const value = (score?: MatchScore) => (score ? `${score.home} – ${score.away}` : '');

export function EventMatchResultSummary({ event }: { event: SchoolEvent }) {
  const result = event.matchResult;
  if (!result || !result.regulation) return null;
  const rows: Array<[string, MatchScore | undefined]> = [
    ['Full time', result.regulation],
    ['Half-time', result.halfTime],
    ['After extra time', result.extraTime],
    ['Penalties', result.shootout]
  ];
  const teams: any[] = (event.embeddedTeams || []).slice(0, 2);
  const nameForTeam = (id: string) => {
    const team = teams.find(item => String(item.id || item._id) === String(id));
    return team && team.name ? team.name : 'Team';
  };

  return (
    <div className="eventMatchResultSummary">
      <header>
        <strong>Match details</strong>
        {event.resultPublication && event.resultPublication.status === 'DRAFT' && <span>Draft</span>}
      </header>
      <div className="eventMatchResultSummary__scores">
        {rows.filter(row => row[1]).map(([label, score]) => (
          <div key={label}><span>{label}</span><b>{value(score)}</b></div>
        ))}
      </div>
      {result.scorers && result.scorers.length > 0 && (
        <div className="eventMatchResultSummary__scorers">
          <strong>Scorers</strong>
          {result.scorers.map((scorer, index) => {
            const period = scorer.period === 'FIRST_HALF' ? '1st half' : scorer.period === 'SECOND_HALF' ? '2nd half' : scorer.period === 'EXTRA_TIME' ? 'extra time' : '';
            const timing = typeof scorer.minute === 'number' ? `${scorer.minute}'${typeof scorer.second === 'number' ? ` ${scorer.second}\"` : ''}` : period;
            return <div key={`${scorer.teamId}-${index}`}><span><b>{scorer.playerNameSnapshot || 'Scorer'}</b><small>{nameForTeam(scorer.teamId)}</small></span>{timing && <em>{timing}</em>}</div>;
          })}
        </div>
      )}
    </div>
  );
}
